import { httpV2 } from "@/api";

/**
 * Solicita o status do protocolo de uma turbina.
 * @param trendSignalSettingId Id do sinal de protocolo da turbina.
 * @returns Indicação de falha de comunicação com protocolo. Ex falha de conexão com modbus.
 */
const Get = function(trendSignalSettingId = 0)
{
	return httpV2.get(`/ProtocolStatus/${trendSignalSettingId}`);
};

/**
 * Solicita o status do protocolo de um conjunto de unidades geradoras.
 * @param monitoringElementIds - Ids das turbinas.
 * @returns Array contendo a indicação de falha de comunicação com protocolo das turbinas.
 */
const GetList = function(monitoringElementIds = [ 0 ])
{
	// Uso de post, pois ultrapassa a quantidade de queryparams de um GET.
	return httpV2.post("/ProtocolStatus/WindTurbines", monitoringElementIds);
};

export default { Get, GetList };